import React from 'react';

const Breadcrumb = ({ title, children }) => (
  <div className="breadcrumbs">
    <div className="breadcrumbs-inner">
      <div className="row m-0 align-items-center">
        <div className="col-sm-4">
          <div className="page-header float-left">
            <div className="page-title">
              <h1>{title}</h1>
            </div>
          </div>
        </div>
        {children && (
          <div className="col-sm-8">
            <div className="float-right">
              {children}
            </div>
          </div>
        )}
      </div>
    </div>
  </div>
);

export default Breadcrumb;
